export default __webpack_public_path__ + "static/media/revenue.7db56f01.svg";